module.exports = __webpack_public_path__ + "img/3976.2d68c7ad.png";